export const processing = {
  'processing.startingAI': 'Starting AI processing...',
  'processing.processingWithAI': 'Processing with AI...',
  'processing.aiComplete': 'AI processing complete',
  'processing.extractedDataFrom': 'Extracted data from',
  'processing.aiProcessingFailed': 'AI processing failed',
  'processing.aiProcessing': 'AI processing in progress...',
  'processing.overallProgress': 'Overall Progress',
  'processing.formGeneration': 'Form generation in progress...',
  'processing.autoCompleting': 'Auto-completing form...',
  'processing.submittingApplication': 'Submitting application...',
  'processing.processingApplication': 'Processing application...'
} as const;